import { useState, useEffect, useRef, Fragment } from "react";
import classes from "../servicetypedetails/ServiceTypeDetails.module.css";
import globalClasses from "../../../commoncomponents/css/Global.module.css";
import InputField from "../../../commoncomponents/input/InputField";
import SelectField from "../../../commoncomponents/dropdown/SelectField";
import CommonCard from "../../../commoncomponents/layout/card/CommonCard";
import ButtonComponent from "../../../commoncomponents/buttons/ButtonComponent";
import { restictDotHyphenAnde } from "../../../../util/GenralUtils";
import Progress from "../../progressbar/RegistrationProgressBar";
import { setSnackbar } from "../../../commoncomponents/alert/SnackbarAction";
import ServiceTypeTable from "./ServiceTypeTable";
import { CLINIC } from "../../userservice/userservice/UserServiceDummyData";
import { getRequest, singoutHandler } from "../../../../api/AxiosAPICall";
import { nanoid } from 'nanoid';
import {
  Autocomplete,
  Backdrop,
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  TextField,
  MenuItem,
  Typography,
} from "@mui/material";
import axios from "axios";
import { FormikProvider } from "formik";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const ServiceTypeDetails = ({
  formik,
  mode,
  organizationAddress,
  sendServiceData,
  clinicData,
}: {
  formik: any;
  mode: any;
  organizationAddress: any;
  sendServiceData: any;
  clinicData: any;
}) => {
  const [country, setCountry] = useState<any>([]);
  const [serviceType, setServiceType] = useState<any>([]);
  const [fetchDistrict, setFetchDistrict] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const isMounted = useRef<any>();
  const [open, setOpen] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [data, setData] = useState([]) as any;
  const [serviceIdForEdit, setServiceIdForEdit] = useState();
  const [disableRegister, setDisableRegister] = useState(false);
  const [disableButton, setDisableButton] = useState(false);
  const [address, setAddress] = useState(false);

  let jwtToken: any;
  if (localStorage.getItem("token") != null) {
    jwtToken = localStorage.getItem("token");
  }
  const dispatch = useDispatch();
  let cancelToken: any;
  let history = useNavigate();
  useEffect(() => {
    setDisableButton(false);
    if (Object.values(data).length === 0) {
      setDisableRegister(true);
    }
  }, [data]);
  const searchDistrict = async (event: any) => {
    const searchText = event.target.value;
    if (searchText.length >= 3) {
      if (typeof cancelToken !== typeof undefined) {
        cancelToken.cancel("Canceling the previous request");
      }

      cancelToken = axios.CancelToken.source();
      setIsLoading(true);
      const response = await getRequest("districtSearch", {
        cancelToken: cancelToken.token,
        params: {
          districtString: searchText,
        },
      });
      setIsLoading(false);
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        setFetchDistrict([]);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setFetchDistrict(response?.data);
      }
    } else {
      setFetchDistrict([]);
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      const response = await getRequest("contries", {});
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setCountry(response?.data);
      }
    };
    fetchCountries();

    const fetchServiceType = async () => {
      isMounted.current = true;
      const response = await getRequest("establishmentListItems", {
        params: {
          applistName: "Clinic Type",
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
      } else {
        setServiceType(response?.data);
      }
    };
    fetchServiceType();
    return () => {
      isMounted.current = false;
      setServiceType([]);
      setCountry([]);
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const fetchClinicData = async () => {
      setOpen(true);
      const response = await getRequest("clinic", {
        headers: {
          Authorization: `Bearer ${jwtToken}`,
        },
      });
      if (response.toString() === "ERROR") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cellmaflex has encounter an issue. Please contact administrator.",
            "top",
            "center"
          )
        );
      } else if (response.toString() !== "" && typeof response !== "object") {
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            response.toString(),
            "top",
            "center"
          )
        );
        if (mode === "edit") {
          singoutHandler(jwtToken);
          localStorage.removeItem("token");
          history("/signin");
        }
      } else {
        formik.setFieldValue("clinicName", response?.data.cliName);

        if (
          formik.values.district === "" ||
          formik.values.district === undefined ||
          formik.values.district === null
        ) {
          formik.setFieldValue(
            "numberAndRoad",
            response?.data.addressJson.addAddress1
          );
          formik.setFieldValue(
            "townCity",
            response?.data.addressJson.addAddress3
          );

          formik.setFieldValue(
            "serviceDistrict",
            response?.data.addressJson.addAddress2
          );
          formik.setFieldValue(
            "countyText",
            response?.data.addressJson.addAddress4
          );

          formik.setFieldValue(
            "postCode",
            response?.data.addressJson.addAddress5
          );

          if (
            country !== null &&
            country !== "" &&
            response?.data.addressJson.addAddress6 !== undefined
          ) {
            let isMatched = false;

            country.forEach((element: any) => {
              if (
                element.couCountry === response?.data.addressJson.addAddress6
              ) {
                isMatched = true;

                return false;
              }
            });

            if (!isMatched) {
              const addAddress = {
                couId: nanoid(),
                couCountryCode: "",
                couCountry: response?.data.addressJson.addAddress6,
                couIcaoCountryCode: "",
              };

              setCountry([...country, addAddress]);

              formik.setFieldValue(
                "country",
                response?.data.addressJson.addAddress6
              );
            } else {
              formik.setFieldValue(
                "country",
                response?.data.addressJson.addAddress6
              );
            }
          }
        }

        formik.setFieldValue(
          "phoneNumber",
          response?.data.addressJson.addPhone
        );

        formik.setFieldValue("mobile", response?.data.addressJson.addMobile);

        formik.setFieldValue(
          `serviceDetails[0].mobile`,
          response?.data.addressJson.addMobile
        );

        formik.setFieldValue("email", response?.data.addressJson.addEmail);

        if (
          serviceType !== null &&
          serviceType !== "" &&
          response?.data.cliType !== undefined
        ) {
          let isMatched = false;
          serviceType.forEach((element: any) => {
            if (element.eliText === response?.data.cliType) {
              isMatched = true;
              return false;
            }
          });

          if (!isMatched) {
            const cliType = {
              eliId: response?.data.cliType,
              eliText: response?.data.cliType,
            };

            setServiceType([...serviceType, cliType]);

            formik.setFieldValue("serviceType", response?.data.cliType);
          } else {
            formik.setFieldValue("serviceType", response?.data.cliType);
          }
        }
      }
      setOpen(false);
    };

    if (mode === "edit") {
      fetchClinicData();
    }

    //eslint-disable-next-line
  }, [serviceType, country]);

  //This function used to set organization address values for service address
  const fetchOrganizationAddressChecked = () => {
    setAddress(true);

    // Set field values first
    formik.setFieldValue("numberAndRoad", organizationAddress?.numberRoad);
    formik.setFieldValue("townCity", organizationAddress?.town);
    formik.setFieldValue("serviceDistrict", organizationAddress?.district);
    formik.setFieldValue("countyText", organizationAddress?.county);
    formik.setFieldValue("country", organizationAddress?.country);
    formik.setFieldValue("phoneNumber", organizationAddress.phoneNo);
    formik.setFieldValue("mobile", organizationAddress?.mobile);
    formik.setFieldValue("email", organizationAddress?.emailId);

    // After setting values, mark fields as touched
    setTimeout(() => {
      formik.setTouched({
        numberAndRoad: true,
        townCity: true,
        serviceDistrict: true,
        countyText: true,
        country: true,
        phoneNumber: true,
        mobile: true,
        email: true,
      });
      setAddress(false);
    }, 500);
  };

  //This function used to unset organization address values for service address
  const fetchOrganizationAddressUnchecked = () => {
    let fields = [
      "numberAndRoad",
      "townCity",
      "countyText",
      "country",
      "phoneNumber",
      "mobile",
      "email",
    ];

    fields.forEach((element: string) => {
      formik.setFieldValue(element, "");
      formik.setFieldTouched(element, false);
    });
  };

  //This function used for reset all form
  const ResetAllField = (formik: any) => {
    let fields = [
      "clinicName",
      "serviceType",
      "numberAndRoad",
      "district",
      "serviceDistrict",
      "townCity",
      "countyText",
      "postCode",
      "country",
      "phoneNumber",
      "mobile",
      "email",
    ];

    fields.forEach((element: string) => {
      formik.setFieldValue(element, "");
      formik.setFieldTouched(element, false);
    });
    formik.setFieldValue("sameAsOrganization", false);
  };

  const handleEdit = async (data: any, index: any) => {
    setServiceIdForEdit(data.serviceId);
    window.scrollTo(0, 0);
    setIsUpdate(true);
    let fields = [
      "clinicName",
      "serviceType",
      "numberAndRoad",
      "serviceDistrict",
      "townCity",
      "countyText",
      "postCode",
      "country",
      "phoneNumber",
      "mobile",
      "email",
    ];

    fields.forEach((element: string) => {
      formik.setFieldValue(element, data[element]);
    });
  };

  const handleUpdate = (data: any, formik: any) => {
    const index = data.findIndex((object: any) => {
      return object.serviceId === serviceIdForEdit;
    });

    if (index !== -1) {
      data[index].serviceId = serviceIdForEdit;
      data[index].clinicName = formik.clinicName;
      data[index].serviceType = formik.serviceType;
      data[index].numberAndRoad = formik.numberAndRoad;
      data[index].district = formik.district;
      data[index].serviceDistrict = formik.serviceDistrict;
      data[index].townCity = formik.townCity;
      data[index].countyText = formik.countyText;
      data[index].country = formik.country;
      data[index].phoneNumber = formik.phoneNumber;
      data[index].mobile = formik.mobile;
      data[index].email = formik.email;
      data[index].sameAsOrganization = false;
    }
  };

  const handleDelete = (event: any, removeIndex: any) => {
    formik.setFieldValue("district", null);
    ResetAllField(formik);
    setIsUpdate(false);
    setData((oldArray: any) => {
      return oldArray.filter((value: any, index: any) => index !== removeIndex);
    });

    dispatch(
      setSnackbar(
        true,
        2000,
        "success",
        "Service Deleted Sucessfully!",
        "top",
        "center"
      )
    );
  };

  const addServiceType = () => {
    if (
      Object.keys(formik?.errors)?.length === 0 &&
      Object.keys(formik?.touched)?.length !== 0
    ) {
      setDisableButton(true);
    }

    setTimeout(() => {
      formik.setTouched({
        clinicName: true,
        serviceType: true,
        numberAndRoad: true,
        serviceDistrict: true,
        country: true,
        mobile: true,
        email: true,
      });

      const isFound = data?.some((element: any) => {
        if (
          formik?.values?.clinicName?.toUpperCase() ===
            element?.clinicName?.toUpperCase() &&
          formik?.values?.serviceType === element?.serviceType &&
          formik?.values?.serviceDistrict === element?.serviceDistrict
        ) {
          return true;
        }
        return false;
      });

      if (isFound) {
        setOpen(false);
        dispatch(
          setSnackbar(
            true,
            undefined,
            "warning",
            "Cannot have two service with similar service type or district, Please enter unique service type or district.",
            "top",
            "center"
          )
        );
      }

      if (
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0 &&
        !isFound &&
        formik.values.clinicName !== undefined &&
        formik.values.clinicName !== "" &&
        formik.values.clinicName !== null
      ) {
        data.push(formik.values);
        ResetAllField(formik);
        formik.setFieldValue("serviceId", +formik?.values?.serviceId + 1);
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "Service Added Sucessfully!",
            "top",
            "center"
          )
        );
        formik.setTouched({
          clinicName: false,
          serviceType: false,
          numberAndRoad: false,
          serviceDistrict: false,
          country: false,
          mobile: false,
          email: false,
        });
        setDisableRegister(false);
      }
      setDisableButton(false);
    }, 500);
  };

  const updateServiceType = () => {
    if (
      Object.keys(formik.errors).length === 0 &&
      Object.keys(formik.touched).length !== 0
    ) {
      setDisableButton(true);
    }

    const isIdFound = data?.some((element: any) => {
      if (
        formik?.values?.clinicName?.toUpperCase() ===
          element?.clinicName?.toUpperCase() &&
        formik?.values?.serviceType === element?.serviceType &&
        formik?.values?.serviceDistrict === element?.serviceDistrict &&
        serviceIdForEdit !== element?.serviceId
      ) {
        return true;
      }
      return false;
    });
    if (isIdFound) {
      dispatch(
        setSnackbar(
          true,
          undefined,
          "warning",
          "Cannot have two service with similar service type or district, Please enter unique service type or district.",
          "top",
          "center"
        )
      );
      setDisableButton(false);
    }

    setTimeout(() => {
      if (
        Object.keys(formik.errors).length === 0 &&
        Object.keys(formik.touched).length !== 0 &&
        !isIdFound
      ) {
        setIsUpdate(false);
        ResetAllField(formik);
        handleUpdate(data, formik.values);
        dispatch(
          setSnackbar(
            true,
            3000,
            "success",
            "Service Updated Sucessfully!",
            "top",
            "center"
          )
        );
      }
      formik.setTouched({
        clinicName: false,
        serviceType: false,
        numberAndRoad: false,
        serviceDistrict: false,
        country: false,
        mobile: false,
        email: false,
      });
      setDisableButton(false);
    }, 500);
  };
  return (
    <Fragment>
      {/* Service Type Information code*/}
      {mode !== "edit" && <Progress activeStep={2} />}
      <FormikProvider value={formik}>
        <Box>
          <CommonCard>
            <Grid container>
              <Grid item md={12}>
                <Typography variant="h1" className={globalClasses.typography}>
                  Service Information
                </Typography>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={2}
              className={classes.rowSpace}
              direction="row"
              sx={{ marginBottom: "20px" }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.formControlZeroMarginTop}
              >
                <input
                  type="hidden"
                  id="serviceId"
                  name="serviceId"
                  value={formik.values.serviceId ?? ""}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                />
                <SelectField
                  id="clinicName"
                  name="clinicName"
                  headerText="Select Clinic"
                  label="Select Clinic"
                  value={formik.values.clinicName}
                  blurevent={formik.handleBlur}
                  changeevent={formik.handleChange}
                  isrequired={true}
                  list={
                    clinicData !== undefined &&
                    clinicData?.clinicDetails !== undefined
                      ? clinicData?.clinicDetails?.map(
                          (clinic: any) => (
                            <MenuItem key={nanoid()} value={clinic.clinicName}>
                              {clinic.clinicName}
                            </MenuItem>
                          )
                        )
                      : CLINIC.map((clinic: any) => (
                          <MenuItem key={nanoid()} value={clinic.value}>
                            {clinic.value}
                          </MenuItem>
                        ))
                  }
                  error={
                    formik.touched.clinicName &&
                    Boolean(formik.errors.clinicName)
                  }
                />
                {formik.touched.clinicName && formik.errors.clinicName && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    {formik.errors.clinicName}
                  </Typography>
                )}
              </Grid>
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                className={classes.formControlZeroMarginTop}
              >
                <SelectField
                  id="serviceType"
                  name="serviceType"
                  headerText="Select service type"
                  label="Select service type"
                  value={formik.values.serviceType}
                  blurevent={formik.handleBlur}
                  changeevent={formik.handleChange}
                  isrequired={true}
                  error={
                    formik.touched.serviceType &&
                    Boolean(formik.errors.serviceType)
                  }
                  list={serviceType.map((sericeType: any) => (
                    <MenuItem key={sericeType.eliId} value={sericeType.eliText}>
                      {sericeType.eliText}
                    </MenuItem>
                  ))}
                />
                {formik.touched.serviceType && formik.errors.serviceType && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    {formik.errors.serviceType}
                  </Typography>
                )}
              </Grid>
            </Grid>

            {/**Service Type Address */}
            <Grid container>
              <Grid item sm={6.2} md={4.1}>
                <Typography variant="h1" className={globalClasses.typography}>
                  Service Address
                </Typography>
              </Grid>
            </Grid>

            <Grid
              container
              spacing={2}
              direction="row"
              sx={{ marginBottom: "20px" }}
            >
              {mode !== "edit" && (
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        id="sameAsOrganization"
                        name="sameAsOrganization"
                        value={formik.values.sameAsOrganization}
                        onChange={(event: any, newValue: any) => {
                          formik.setFieldValue("sameAsOrganization", newValue);
                        }}
                        checked={formik.values.sameAsOrganization}
                      />
                    }
                    label="Same as organization"
                    value={formik.values.sameAsOrganization}
                    onChange={(event: any, newValue: any) => {
                      formik.setFieldValue("sameAsOrganization", newValue);
                    }}
                    onClick={() => {
                      !formik.values.sameAsOrganization
                        ? fetchOrganizationAddressChecked()
                        : fetchOrganizationAddressUnchecked();
                    }}
                  />
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={4}>
                <Autocomplete
                  freeSolo
                  disableClearable
                  value={formik.values.district}
                  clearOnBlur
                  options={fetchDistrict}
                  getOptionLabel={(district: any) => district.adlAddress2 ?? ""}
                  renderOption={(props: any, district: any) => (
                    <Box component="li" {...props} key={district.adlId}>
                      {(district.adlAddress2
                        ? district.adlAddress2 + ", "
                        : "") +
                        (district.adlTown ? district.adlTown + ", " : "") +
                        (district.adlAddress4
                          ? district.adlAddress4 + ", "
                          : "") +
                        (district.adlAddress6 ? district.adlAddress6 : "")}
                    </Box>
                  )}
                  loading={isLoading}
                  onChange={(event, newValue: any) => {
                    formik.setFieldValue("district", "");
                    formik.setFieldValue(
                      "serviceDistrict",
                      newValue.adlAddress2 ?? ""
                    );
                    formik.setFieldValue("townCity", newValue.adlTown ?? "");

                    formik.setFieldValue(
                      "countyText",
                      newValue.adlAddress4 ?? ""
                    );

                    formik.setFieldValue(
                      "postCode",
                      newValue.adlAddress5 ?? ""
                    );

                    if (
                      country !== null &&
                      country !== "" &&
                      newValue.adlAddress6 !== undefined
                    ) {
                      let isMatched = false;
                      country.forEach((element: any) => {
                        if (element.couCountry === newValue.adlAddress6 ?? "") {
                          isMatched = true;
                          return false;
                        }
                      });

                      if (!isMatched) {
                        const addAddress = {
                          couId: nanoid(),
                          couCountryCode: "",
                          couCountry: newValue.adlAddress6 ?? "",
                          couIcaoCountryCode: "",
                        };

                        setCountry([...country, addAddress]);
                        formik.setFieldValue(
                          "country",
                          newValue.adlAddress6 ?? ""
                        );
                      } else {
                        formik.setFieldValue(
                          "country",
                          newValue.adlAddress6 ?? ""
                        );
                      }
                    }

                    setFetchDistrict([]);
                  }}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="district"
                      name="district"
                      label="District search"
                      variant="outlined"
                      size="small"
                      onChange={(event: any) => {
                        searchDistrict(event);
                      }}
                      InputProps={{
                        ...params.InputProps,
                        type: "search",
                      }}
                      autoComplete="off"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="numberAndRoad"
                  name="numberAndRoad"
                  label="Number & Road"
                  inputvalues={formik.values.numberAndRoad}
                  errormessage={
                    formik.touched.numberAndRoad &&
                    Boolean(formik.errors.numberAndRoad)
                  }
                  message={
                    formik.touched.numberAndRoad && formik.errors.numberAndRoad
                  }
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="townCity"
                  name="townCity"
                  label="Town/City"
                  inputvalues={formik.values.townCity}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                />
              </Grid>
              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="serviceDistrict"
                  name="serviceDistrict"
                  label="District"
                  disable={true}
                  inputvalues={formik.values.serviceDistrict}
                  errormessage={
                    formik.touched.serviceDistrict &&
                    Boolean(formik.errors.serviceDistrict)
                  }
                  message={
                    formik.touched.serviceDistrict &&
                    formik.errors.serviceDistrict
                  }
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="countyText"
                  name="countyText"
                  label="County"
                  inputvalues={formik.values.countyText}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <SelectField
                  id="country"
                  name="country"
                  headerText="Select country"
                  label="Select country"
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  value={formik?.values?.country}
                  error={
                    formik.touched.country && Boolean(formik.errors.country)
                  }
                  isrequired={true}
                  list={country.map((country: any) => (
                    <MenuItem key={country.couId} value={country.couCountry}>
                      {country.couCountry}
                    </MenuItem>
                  ))}
                />

                {formik.touched.country && formik.errors.country && (
                  <Typography
                    color="#d32f2f"
                    component={"p"}
                    variant="subtitle2"
                    sx={{ fontSize: "12px", padding: "5px" }}
                  >
                    {formik.errors.country}
                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="phoneNumber"
                  name="phoneNumber"
                  label="Phone Number"
                  type="number"
                  inputvalues={formik.values.phoneNumber}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  downevent={restictDotHyphenAnde}
                  errormessage={
                    formik.touched.phoneNumber &&
                    Boolean(formik.errors.phoneNumber)
                  }
                  message={
                    formik.touched.phoneNumber && formik.errors.phoneNumber
                  }
                  placeholder="e.g. 7777777"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="mobile"
                  name="mobile"
                  type="number"
                  label="Mobile"
                  inputvalues={formik.values.mobile}
                  errormessage={
                    formik.touched.mobile && Boolean(formik.errors.mobile)
                  }
                  message={formik.touched.mobile && formik.errors.mobile}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  downevent={restictDotHyphenAnde}
                  placeholder="e.g. 8888888888"
                />
              </Grid>

              <Grid item xs={12} sm={6} md={4}>
                <InputField
                  id="email"
                  name="email"
                  label="Email"
                  inputvalues={formik.values.email}
                  errormessage={
                    formik.touched.email && Boolean(formik.errors.email)
                  }
                  message={formik.touched.email && formik.errors.email}
                  changeevent={formik.handleChange}
                  blurevent={formik.handleBlur}
                  isrequired={true}
                />
              </Grid>
            </Grid>

            {mode !== "edit" && (
              <Grid
                item
                xs={12}
                md={12}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginBottom: "15px",
                }}
              >
                {isUpdate ? (
                  <ButtonComponent
                    buttonclass={globalClasses.addAnotherServiceGreen}
                    variant="contained"
                    size="small"
                    onClick={(event: any) => {
                      updateServiceType();
                      event.preventDefault();
                    }}
                    disable={disableButton}
                    label="Update"
                  />
                ) : (
                  <form>
                    <ButtonComponent
                      buttonclass={globalClasses.addAnotherServiceGreen}
                      variant="contained"
                      size="small"
                      onClick={(event: any) => {
                        addServiceType();
                        event.preventDefault();
                      }}
                      disable={disableButton}
                      label="Add Service"
                    />
                  </form>
                )}
              </Grid>
            )}
          </CommonCard>
        </Box>
        <ServiceTypeTable
          getData={data}
          setData={handleEdit}
          isLoading={async () => {
            setOpen(true);
          }}
          deleteService={handleDelete}
        />

        {mode !== "edit" && (
          <Grid container spacing={2} direction="row">
            <Grid item xs={12} md={12}>
              <form>
                <ButtonComponent
                  variant="contained"
                  size="small"
                  type="submit"
                  buttonclass={classes.nextButton}
                  onClick={(event: any) => {
                    sendServiceData(data);
                    event.preventDefault();
                  }}
                  label="Next"
                  disable={disableRegister}
                />
              </form>
            </Grid>
          </Grid>
        )}
      </FormikProvider>

      {(open || disableButton) && (
        <Backdrop
          sx={{
            color: "#fff",
            zIndex: 1500,
            display: "flex",
            flexDirection: "column",
          }}
          open
        >
          <Typography fontWeight="600" fontSize="20px">
            Loading Service Type Information...!
          </Typography>
          <CircularProgress color="primary" sx={{ margin: "20px" }} />
        </Backdrop>
      )}

      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 1500,
          display: "flex",
          flexDirection: "column",
        }}
        open={address}
      >
        <Typography fontWeight="600" fontSize="20px">
          Loading Address Information...!
        </Typography>
        <CircularProgress color="primary" sx={{ margin: "20px" }} />
      </Backdrop>
    </Fragment>
  );
};

export default ServiceTypeDetails;
